import axios from "axios";
import { checkAuth } from "../logic";
import { store } from "../../redux/store";
import { showModal } from "../../redux/dispatchers";
import { logoutUser } from "../logic";

/**
 * @deprecated
 */
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// check for token
axiosInstance.interceptors.request.use(
  async (config) => {
    const authenticated = await checkAuth();
    // call logout when the accesstoken and refreshtoken are expired
    if (!authenticated) {
      const { accessToken } = store.getState().authDetails;

      if (accessToken) {
        showModal(
          "Session Expired",
          "Your session has expired. Please login again.",
          null,
          "Close"
        );
      }

      await logoutUser();

      throw new Error("Unauthorized");
    } else {
      // set the new accesstoken to the request headers
      const { accessToken } = store.getState().authDetails;
      config.headers.Authorization = `Bearer ${accessToken}`;
      return config;
    }
  },
  (err) => {
    console.log(err);
    return Promise.reject(err);
  }
);

// middleware after request
axiosInstance.interceptors.response.use(
  (res) => res,
  async (err) => {
    const { accessToken } = store.getState().authDetails;
    // log out user if api hit 401
    if (err.response && err.response.status === 401 && accessToken) {
      await logoutUser();
      showModal(
        "Session Expired",
        "Your session has expired. Please login again.",
        null,
        "Close"
      );
    } else {
      showModal(
        "Unexpected Error",
        "Try to refresh or log out.",
        null,
        "Close"
      );
    }

    throw err;
  }
);

export default axiosInstance;
